import { render, staticRenderFns } from "./pubWeMedia.vue?vue&type=template&id=03ae5990&scoped=true"
import script from "./pubWeMedia.vue?vue&type=script&lang=js"
export * from "./pubWeMedia.vue?vue&type=script&lang=js"
import style0 from "./pubWeMedia.vue?vue&type=style&index=0&id=03ae5990&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ae5990",
  null
  
)

export default component.exports